import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useConfig } from '../../context/ConfigContext';
import { useHealthQuery } from '../../graphql/hooks/useHealthQuery';

export const VersionCheckObserver = () => {
  const { config } = useConfig();

  const { data } = useHealthQuery({
    refetchInterval: 20000,
    useErrorBoundary: true,
  });

  const currentServerVersion = data?.buildInfo?.commit ?? null;
  const currentClientVersion = config.buildInfo.commit;

  const outOfDate = React.useMemo(() => {
    return (
      currentClientVersion && currentServerVersion && currentClientVersion !== currentServerVersion
    );
  }, [currentClientVersion, currentServerVersion]);

  const refreshPage = () => {
    window.location.reload();
  };

  if (!outOfDate) {
    return null;
  }

  return (
    <ChakraV3.Alert.Root
      status='info'
      bg='purple.500'
      variant='solid'
      flexDirection='row'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
      rounded='none'
      border='none'
      position='fixed'
      textStyle='md'
      top={0}
      zIndex={9999}
    >
      <ChakraV3.HStack gap={4}>
        <ChakraV3.HStack>
          <ChakraV3.Alert.Title color='white' fontWeight='semibold'>
            Piccolo has been updated.
          </ChakraV3.Alert.Title>
          <ChakraV3.Alert.Description color='white'>
            Please refresh the page to get the latest version.
          </ChakraV3.Alert.Description>
        </ChakraV3.HStack>
        <ChakraV3.Button size='2xs' bg='gray.100' color='purple.500' onClick={refreshPage}>
          Refresh
        </ChakraV3.Button>
      </ChakraV3.HStack>
    </ChakraV3.Alert.Root>
  );
};
